// Charge la base commune
import './common.js'

// Contact Form
async function getCForm ($f, initializeEstimate = false) {
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
    if (initializeEstimate) { $(document).trigger('startEstimate') }
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // formulaire de contact
  const $c = $('form[name="cForm"]')
  $c.waypoint(function () {
    $c.load()
    getCForm($c)
    this.destroy()
  }, {
    offset: '100%'
  })

  $('#estimate').on('click', function () {
    $c.load()
    getCForm($c, true)
  })

  if ($('#go').length) {
    const h = $('#header').height()
    // const p = $(this).parents('.pajinate-nav').height()
    const t = $('#go')
    $('html, body').animate({ scrollTop: $(t).offset().top - $('#header').height() - h - 10 }, 300, function () {
      console.log('test')
      $('#estimate').trigger('click')
    })
  }
})
